import { doGraphqlRequest } from 'ducks/requests'
import { selectIntegrationCredentialsForId } from 'ducks/integrations'
import * as types from '../types'

const mutation = `
  mutation EventShopifyCreate(
    $changeType: ShopifyChangeType!,
    $conversationId: ID!,
    $externalId: String!,
    $meta: JSON,
    $shopDomain: String!
  ) {
    eventsShopifyCreate(input: {
      changeType: $changeType,
      conversationId: $conversationId,
      externalId: $externalId,
      meta: $meta,
      shopDomain: $shopDomain
    }) {
      event {
        id
      }
      errors {
        message
        path
      }
    }
  }

`

const changeTypes = [
  'ORDER_CANCELED',
  'ORDER_CREATED',
  'ORDER_DUPLICATED',
  'ORDER_REFUNDED',
]

const doCreateShopifyEvent = (
  integrationId,
  orderId,
  conversationId,
  changeType
) => (dispatch, getState) => {
  const integration = selectIntegrationCredentialsForId(getState(), {
    id: integrationId,
  })
  const { storeDomain } = integration

  if (!changeTypes.find(type => type === changeType)) {
    throw new Error(`Unknown type ${changeType}`)
  }

  const variables = {
    changeType,
    conversationId,
    externalId: orderId.split('/').pop(), // convert global ids to regular ids
    meta: {},
    shopDomain: storeDomain,
  }

  return dispatch(
    doGraphqlRequest(types.SHOPIFY_EVENT_CREATE_REQUEST, mutation, variables, {
      app: true,
    })
  )
}

export default doCreateShopifyEvent
